import request from '@/utils/request'
const URL = '/health-doctor-assistant'
// 获取复诊提醒工单子任务状态
export function getSMSInfo(data) {
  return request({
    url: URL + '/sms-info/page',
    method: 'post',
    data
  })
}
export function checkSendStatus(params) {
  return request({
    url: URL + '/sendSms/checkSmsRestrictions',
    method: 'get',
    params
  })
}
export function smsTemplateContent(data) {
  return request({
    url: URL + '/smsTemplateContent/list',
    method: 'post',
    data
  })
}
// 发送短信
export function sendSms(data) {
  return request({
    url: URL + '/sendSms/sendSms',
    method: 'post',
    data
  })
}
